export const BACKEND_API_URL = import.meta.env.VITE_API_BACKEND_URL || "";
export const SSO_CLIENT_ID = import.meta.env.VITE_SSO_CLIENT_ID || "";
export const SSO_TENANT_ID = import.meta.env.VITE_SSO_TENANT_ID || "";
export const API_CLIENT_ID = import.meta.env.VITE_API_CLIENT_ID || "";
